import { createContext, useEffect, useState } from 'react'
import { useGetModulosByProject } from 'lib/react-query/queriesModuloType'

export const ResumenContext = createContext()

export const ResumenProvider = ({ children }) => {
  const { isLoading: isLoadingModulos, isError: isErrorModulos } =
    useGetModulosByProject()

  if (isLoadingModulos) return null

  return <ResumenContext.Provider> {children} </ResumenContext.Provider>
}
